import {combineReducers} from 'redux';
import sessionReducer from './session';
import unitsReducer from './unit';

/**
 * The root reducer interface that contains the
 * required reducers to interact with the global state.
 * @type {Reducer<any>}
 */
const rootReducer = combineReducers({
    sessionState: sessionReducer,
    unitsState: unitsReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js